import { BELIEFS, IMAGES } from "@/lib/content";
import { STORY_PULL_QUOTE } from "@/lib/story";
import { Reveal } from "./Reveal";

export const Belief = () => (
  <section id="belief" className="bg-pine text-sage py-24 md:py-32 scroll-mt-20" data-testid="belief-section">
    <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[1.4fr_1fr] gap-12 items-center">
      <Reveal className="min-w-0">
        <svg viewBox="0 0 400 60" className="w-48" aria-hidden="true">
          <path className="dr" pathLength="1" d="M0 30C80 0 120 60 200 30S320 0 400 30" fill="none" stroke="#e3a57c" strokeWidth="2" />
        </svg>
        <h2 className="dp mt-6"><em>We've lived military life ourselves.</em></h2>
        <ul className="mt-8 grid sm:grid-cols-2 gap-4" data-testid="belief-list">
          {BELIEFS.map((b) => (
            <li key={b} className="flex gap-3 text-mist">
              <span className="mt-2.5 h-px w-5 shrink-0 bg-brass-light" aria-hidden="true" />
              {b}
            </li>
          ))}
        </ul>
      </Reveal>
      <Reveal delay={150}>
        <figure className="relative aspect-square rounded-full overflow-hidden bg-pine-soft">
          <img src={IMAGES.founders} alt="Don and Lorrie Gramer, founders of Military Marriages Matter" className="absolute inset-0 h-full w-full object-cover object-[50%_35%]" loading="lazy" data-testid="founders-image" />
          <figcaption className="absolute bottom-[12%] left-1/2 -translate-x-1/2 lb bg-pine/80 text-mist px-3 py-1.5 rounded-full text-center max-w-[78%] sm:max-w-none sm:whitespace-nowrap" data-testid="founders-caption">
            Don &amp; Lorrie Gramer, founders
          </figcaption>
        </figure>
        <div className="mt-8" data-testid="founders-story">
          <p className="lb text-brass-light">Meet Don &amp; Lorrie</p>
          <p className="mt-3 dp text-2xl leading-snug"><em>“{STORY_PULL_QUOTE}”</em></p>
          <p className="mt-3 text-mist">
            Don flew Cobra gunships in Vietnam and left the Army a Chief Warrant Officer II. He and Lorrie have walked through PTSD together across 54 years of marriage.
          </p>
          <a href="/our-story" className="mt-4 inline-block underline underline-offset-4 decoration-brass-light" data-testid="founders-read-story-link">Read our story →</a>
        </div>
      </Reveal>
    </div>
  </section>
);
